import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { AiRealceService } from './ai-realce.service';

/**
 * Faróis do assistente (spec §6.1) — irmão do `<tour-realce>`: desenhados POR CIMA do alvo,
 * `pointer-events: none`, cor de destaque do assistente (não a `--main-200` do tour) e pulso
 * próprio, para nunca se confundir com o farol do tour. Sob SSR o serviço nunca publica nada.
 */
@Component({
  selector: 'ai-realce',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @for (r of realce.retangulos(); track $index) {
      <div class="farol-ai" aria-hidden="true"
           [style.top.px]="r.top" [style.left.px]="r.left"
           [style.width.px]="r.width" [style.height.px]="r.height"></div>
    }
  `,
  styles: [`
    .farol-ai {
      position: fixed;
      pointer-events: none;
      z-index: 9990;
      border-radius: 8px;
      box-shadow: 0 0 0 2px var(--ai-accent, var(--main-100, #109ccd));
      box-shadow:
        0 0 0 2px var(--ai-accent, var(--main-100, #109ccd)),
        0 0 0 6px color-mix(in srgb, var(--ai-accent, var(--main-100, #109ccd)) 22%, transparent);
      animation: farol-ai-pulso 0.9s ease-out 2;
    }
    @keyframes farol-ai-pulso {
      0%   { box-shadow: 0 0 0 2px var(--ai-accent, var(--main-100, #109ccd)); }
      60%  { box-shadow: 0 0 0 2px var(--ai-accent, var(--main-100, #109ccd)),
                         0 0 0 12px color-mix(in srgb, var(--ai-accent, var(--main-100, #109ccd)) 0%, transparent); }
      100% { box-shadow: 0 0 0 2px var(--ai-accent, var(--main-100, #109ccd)),
                         0 0 0 6px color-mix(in srgb, var(--ai-accent, var(--main-100, #109ccd)) 22%, transparent); }
    }
    @media (prefers-reduced-motion: reduce) { .farol-ai { animation: none; } }
  `],
})
export class AiRealceComponent {
  readonly realce = inject(AiRealceService);
}
